import { render, staticRenderFns } from "./SimpleActivity.vue?vue&type=template&id=facac546&"
import script from "./SimpleActivity.vue?vue&type=script&lang=js&"
export * from "./SimpleActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports